export default __webpack_public_path__ + "static/media/TSALogo.7100db14.png";